











































































































































import ApiConfiguration from '@/classes/ApiConfiguration';
import DocumentViewer from '@/components/shared/DocumentViewer.vue';
import MStoreFormDatePicker from '@/components/shared/MStoreFormDatePicker.vue';
import { DocumentsToReviewCountModel, DocumentsToReviewModel, DocumentTabModel, DocumentUpdateRetentionUpdateParams, RetentionType, SearchResultsDocumentModel } from '@/services/GeneratedApi';
import { BaseDocumentSearchModel, CabinetConstants, ColourVariantType, DocumentRetentionPendType, DocumentViewerConstants, DocumentViewerToolbarOptionsModel, ModalConstants } from '@/types';
import { ArrayUtils, DateUtils, SelectableTableUtils } from '@/utils';
import moment from 'moment';
import qs from 'qs';
import Vue from 'vue';
import { mapActions } from 'vuex';
import Toast from '@/classes/SnotifyConfiguration';
import { ModalHelpers } from '@/mixins';

export default Vue.extend({
  name: 'DocumentRetention',
  props: {},
  data() {
    return {
      isLoading: true,
      isUpdating: false,
      retentionCounts: {} as DocumentsToReviewCountModel,
      cabinetFilter: undefined,
      documentTypeFilter: undefined,
      isFetchingDocumentsToReview: false,
      documentsToReview: undefined,
      selectedDocuments: [] as number[],
      isRefreshingCounts: false,
      currentPage: 1,
      documentIdBeingDisplayed: 0,
      isTabExpanded: true,
      selectedTabIndex: 0,
      pendType: DocumentRetentionPendType.ThreeMonths,
      pendDays: 1,
      pendDate: moment()
        .startOf('day')
        .add(1, 'days')
        .format('YYYY-MM-DD'),
      exportOptions: DocumentViewerConstants.WithoutAcquiringLockExportOptions,
      isDeleting: false,
      isPending: false,
      showDocInfo: true,
      showRetentionTab: false
    };
  },
  computed: {
    orderedCabinets(
      this: any
    ): Array<{ cabinetId: string; cabinetDescription: string; totalToReview: number; documentTypes: Array<{ documentTypeId: number; documentTypeDescription: string; totalToReview: number }> }> {
      const cabinetsToReviewCounts = (this.retentionCounts as DocumentsToReviewCountModel).cabinetsToReviewCounts!;
      const orderedCabinetsWithDocumentTypes: Array<{
        cabinetId: string;
        cabinetDescription: string;
        totalToReview: number;
        documentTypes: Array<{ documentTypeId: number; documentTypeDescription: string; totalToReview: number }>;
      }> = ArrayUtils.alphabeticalSort(
        Object.entries(cabinetsToReviewCounts).map(([cabinetId, { cabinetDescription, totalToReview, documentTypesToReviewCounts }]) => ({
          cabinetId,
          cabinetDescription: cabinetDescription!,
          totalToReview: totalToReview!,
          documentTypes: ArrayUtils.alphabeticalSort(
            Object.entries(documentTypesToReviewCounts!).map(([documentTypeId, { documentTypeDescription, totalToReview: documentTypeTotalToReview }]) => ({
              documentTypeId: Number(documentTypeId),
              documentTypeDescription: documentTypeDescription!,
              totalToReview: documentTypeTotalToReview!
            })),
            ({ documentTypeDescription }) => documentTypeDescription
          )
        })),
        ({ cabinetDescription }) => cabinetDescription
      );

      return orderedCabinetsWithDocumentTypes;
    },
    filterText(this: any) {
      if (!this.cabinetFilter) {
        return 'Filter...';
      }

      const cabinetToReview = (this.retentionCounts as DocumentsToReviewCountModel).cabinetsToReviewCounts![this.cabinetFilter];
      if (!this.documentTypeFilter || !cabinetToReview.documentTypesToReviewCounts![this.documentTypeFilter]) {
        return cabinetToReview.cabinetDescription;
      }

      const documentTypeToReview = cabinetToReview.documentTypesToReviewCounts![this.documentTypeFilter];
      return `${cabinetToReview.cabinetDescription} - ${documentTypeToReview.documentTypeDescription}`;
    },
    fields(this: any) {
      const defaultFields: Array<{ key: string; description: string }> = [
        { key: CabinetConstants.DocumentFields.DocId, description: 'Document Id' },
        { key: CabinetConstants.DocumentFields.DocumentDate, description: 'Document Date' },
        { key: CabinetConstants.DocumentFields.FileType, description: 'File Type' },
        { key: CabinetConstants.DocumentFields.PageCount, description: 'Pages' },
        { key: CabinetConstants.DocumentFields.CreatedDate, description: 'Created Date' }
      ];

      if (!this.documentsToReview) {
        return defaultFields;
      }

      const cabinetFields: Array<{ key: string; description: string }> = Object.entries(this.documentsToReview.cabinetReferenceDescriptions as Record<string, string>).map(([key, description]) => ({
        key,
        description
      }));

      let documentFields: Array<{ key: string; description: string }> = [];
      if (Object.keys(this.documentsToReview.documentReferenceDescriptions).length === 1) {
        const singleDocumentTypeReferenceDescriptions = Object.values(this.documentsToReview.documentReferenceDescriptions as Record<number, Record<string, string>>)[0];
        documentFields = singleDocumentTypeReferenceDescriptions ? Object.entries(singleDocumentTypeReferenceDescriptions).map(([key, description]) => ({ key, description })) : [];
      } else {
        const allDocumentReferenceKeys = new Set(
          Object.values((this.documentsToReview as DocumentsToReviewModel).documentReferenceDescriptions!)
            .map(Object.keys)
            .flatMap((x) => x)
        );
        documentFields = Array.from(allDocumentReferenceKeys).map((key) => ({ key, description: `Document ${/[0-9]+$/.exec(key)?.[0]}` }));
      }

      return [...defaultFields, ...cabinetFields, ...documentFields];
    },
    paginatedItems(this: any) {
      const items = (this.documentsToReview as DocumentsToReviewModel)?.data?.slice((this.currentPage - 1) * this.DOCUMENTS_PER_PAGE, this.currentPage * this.DOCUMENTS_PER_PAGE) ?? [];
      return items.map((x) => ({
        ...x,
        [CabinetConstants.DocumentFields.DocumentDate]: DateUtils.formatDateWithoutTime(x[CabinetConstants.DocumentFields.DocumentDate]),
        [CabinetConstants.DocumentFields.CreatedDate]: DateUtils.formatDateWithoutTime(x[CabinetConstants.DocumentFields.CreatedDate])
      }));
    },
    documentBeingDisplayed(this: any) {
      return (this.documentsToReview as DocumentsToReviewModel)?.data?.find(({ [CabinetConstants.DocumentFields.DocId]: DocId }) => DocId === this.documentIdBeingDisplayed) ?? undefined;
    },
    informationFields(this: any) {
      return (this.fields as Array<{ key: string; description: string }>)?.filter(
        (x) => !x.key.startsWith(CabinetConstants.DocumentFields.CabinetReferencePrefix) && !x.key.startsWith(CabinetConstants.DocumentFields.DocumentReferencePrefix)
      );
    },
    referenceFields(this: any) {
      return (this.fields as Array<{ key: string; description: string }>).filter(
        (x) => x.key.startsWith(CabinetConstants.DocumentFields.CabinetReferencePrefix) || x.key.startsWith(CabinetConstants.DocumentFields.DocumentReferencePrefix)
      );
    },
    isCustomDays(this: any) {
      return this.pendType === DocumentRetentionPendType.SpecifiedDays;
    },
    isCustomDate(this: any) {
      return this.pendType === DocumentRetentionPendType.SpecifiedDate;
    },
    documentViewerToolbarOptions(this: any): DocumentViewerToolbarOptionsModel {
      const options: DocumentViewerToolbarOptionsModel = {
        allowPageNavigation: true,
        allowPageDelete: true,
        allowDocumentDelete: true,
        showEditReferences: true,
        pageDeleteNotAllowedTooltip: '',
        documentDeleteNotAllowedTooltip: ''
      };
      return options;
    },
    hasErrors(this: any) {
      // Check for pend date and days errors
      return !!this.errors.first('pendDateValidationErrors') || !this.isPendDaysValid;
    },
    isPendDaysValid(this: any) {
      // Only validate if custom days is active
      if (!this.isCustomDays) {
        return true;
      }
      const days = parseInt(this.pendDays, 10);
      return !isNaN(days) && days > 0;
    },
    selectedDocumentsToDelete(this: any) {
      // If you want to search all documents, use this.documentsToReview.data instead of paginatedItems
      const allDocs = this.documentsToReview?.data ?? [];
      // Map each doc to a SearchResultsDocumentModel
      return allDocs
        .filter((doc: any) => this.selectedDocuments.includes(doc.CB_DOCID))
        .map((doc: any) => ({
          documentId: doc.CB_DOCID,
          cabinetId: this.cabinetFilter,
          documentTypeId: doc.CB_DTID,
          pages: doc.CB_PAGES
          // ...add any other fields required by SearchResultsDocumentModel...
          // ...doc // spread to include any extra fields if needed
        })) as SearchResultsDocumentModel[];
    },
    cabinetId(this: any): number | undefined {
      return this.cabinetFilter ? Number(this.cabinetFilter) : undefined;
    }
  },
  methods: {
    ...mapActions('documentViewStore', ['setDocumentSearchModel', 'loadPage', 'unloadDocument', 'retrieveDocumentActions']),
    onBackgroundDeleteCompleted(this: any) {
      // Remove deleted documents from the data source
      const deletedIds = this.selectedDocumentsToDelete.map((doc: any) => doc.documentId);
      if (this.documentsToReview?.data) {
        this.documentsToReview.data = this.documentsToReview.data.filter((doc: any) => !deletedIds.includes(doc.CB_DOCID));
      }
      // Clear selection
      this.selectedDocuments = [];
      // Optionally, reset the displayed document if it was deleted
      if (deletedIds.includes(this.documentIdBeingDisplayed)) {
        this.documentIdBeingDisplayed = 0;
      }
    },
    async getRetentionCounts(this: any) {
      this.isRefreshingCounts = true;
      try {
        this.retentionCounts = await ApiConfiguration.api().tools.toolsDocumentRetentionList();
        const cabinets = this.retentionCounts?.cabinetsToReviewCounts || {};
        if (!this.cabinetFilter || !cabinets[this.cabinetFilter]) {
          this.cabinetFilter = undefined;
          this.documentTypeFilter = undefined;
          this.documentIdBeingDisplayed = 0;
          this.selectedDocuments = [];
          this.documentsToReview = undefined;
        }
      } finally {
        this.isRefreshingCounts = false;
      }
    },
    async validForRetention(this: any, cabinetId: string, documentId: number) {
      return await ApiConfiguration.api().document.documentValidForRetentionUpdate({ cabinetId, documentId });
    },
    async setFilter(this: any, cabinetId: string, documentTypeId?: number) {
      this.cabinetFilter = cabinetId;
      this.documentTypeFilter = documentTypeId;
      this.documentIdBeingDisplayed = 0;
      await this.getDocumentsToReview();
    },
    async getDocumentsToReview(this: any) {
      this.isFetchingDocumentsToReview = true;
      const documentTypeIds: number[] = this.documentTypeFilter
        ? [this.documentTypeFilter]
        : Object.keys((this.retentionCounts as DocumentsToReviewCountModel).cabinetsToReviewCounts![this.cabinetFilter].documentTypesToReviewCounts!);
      try {
        const documentsToReview = await ApiConfiguration.api().tools.toolsDocumentRetentionDetail(
          { cabinetId: this.cabinetFilter, documentTypeIds },
          {
            paramsSerializer(params) {
              return qs.stringify(params);
            }
          }
        );
        this.documentsToReview = documentsToReview;
      } finally {
        this.isFetchingDocumentsToReview = false;
        const exists = this.documentsToReview?.data?.some((doc: any) => doc.CB_DOCID === this.documentIdBeingDisplayed);
        if (!exists) {
          await this.onRowClicked(this.documentsToReview?.data[0]?.CB_DOCID ?? 0);
        }
      }
    },
    toggleDocumentSelection(this: any, docId: number) {
      this.selectedDocuments = SelectableTableUtils.DefaultSelectItem(this.selectedDocuments, docId);
    },
    toggleAllDocumentsSelection(this: any) {
      this.selectedDocuments = SelectableTableUtils.DefaultSelectItems(
        this.selectedDocuments,
        (this.paginatedItems as Array<Record<string, any>>).map((x) => x[CabinetConstants.DocumentFields.DocId])
      );
    },
    onRefreshButtonClicked(this: any) {
      this.getRetentionCounts();
      if (this.cabinetFilter) {
        this.getDocumentsToReview();
      }
    },
    openTab(this: any, index: number) {
      this.isTabExpanded = true;
      this.selectedTabIndex = index;
    },
    async onPendClick(this: any) {
      // Pend it
      this.isPending = true;
      const today = moment().startOf('day');
      if (this.pendType === DocumentRetentionPendType.ThreeMonths) {
        this.pendDate = today
          .clone()
          .add(3, 'months')
          .format('YYYY-MM-DD');
      } else if (this.pendType === DocumentRetentionPendType.SixMonths) {
        this.pendDate = today
          .clone()
          .add(6, 'months')
          .format('YYYY-MM-DD');
      } else if (this.pendType === DocumentRetentionPendType.OneYear) {
        this.pendDate = today
          .clone()
          .add(1, 'year')
          .format('YYYY-MM-DD');
      } else if (this.pendType === DocumentRetentionPendType.TwoYears) {
        this.pendDate = today
          .clone()
          .add(2, 'years')
          .format('YYYY-MM-DD');
      } else if (this.pendType === DocumentRetentionPendType.FiveYears) {
        this.pendDate = today
          .clone()
          .add(5, 'years')
          .format('YYYY-MM-DD');
      } else if (this.pendType === DocumentRetentionPendType.SpecifiedDays) {
        // Ensure pendDays is a positive integer
        const days = parseInt(this.pendDays, 10);
        if (!isNaN(days) && days > 0) {
          this.pendDate = today
            .clone()
            .add(days, 'days')
            .format('YYYY-MM-DD');
        }
      }

      // Now validate the date before proceeding
      if (!this.validatePendDate(this.pendDate)) {
        return;
      }

      await this.updateRetentionAsync();
      this.isPending = false;
    },
    async onDeleteClick(this: any) {
      if (
        await ModalHelpers.methods.showConfirmationModalAsync(this.$bvModal, 'Are you sure you want to permanently delete this document?', {
          okVariant: ColourVariantType.Danger,
          cancelVariant: ColourVariantType.Primary,
          okTitle: ModalConstants.deleteConfirmationText
        })
      ) {
        this.isDeleting = true;
        await this.updateRetentionAsync(true);
        this.isDeleting = false;
      }
    },
    viewDocument(this: any, documentId: number, cabinetId: string) {
      this.unloadDocument();
      this.setDocumentSearchModel({ cabinetId, documentId } as BaseDocumentSearchModel);
      this.retrieveDocumentActions();
      this.loadPage(1);
    },
    async onRowClicked(this: any, documentId: number) {
      if (documentId > 0) {
        this.showRetentionTab = false;
        this.showDocInfo = false;
        this.documentIdBeingDisplayed = documentId;
        // Find the selected document in your data
        const doc = this.paginatedItems.find((x: any) => x.CB_DOCID === documentId);
        if (doc) {
          this.viewDocument(doc.CB_DOCID, this.cabinetFilter);
        }
        this.$nextTick(() => {
          this.showDocInfo = true;
        });

        try {
          await this.validForRetention(this.cabinetFilter, documentId);
          this.showRetentionTab = true;
        } catch (error) {
          this.$log('Document is not valid for retention:', error);
        }
      }
    },
    async updateRetentionAsync(this: any, isDelete: boolean = false) {
      this.isUpdating = true;
      try {
        const docs = this.documentsToReview.data;
        const currentIdx = docs.findIndex((doc: any) => doc.CB_DOCID === this.documentIdBeingDisplayed);

        const updatePayload = {
          CabinetId: this.cabinetFilter,
          DocumentId: this.documentIdBeingDisplayed,
          RetentionDate: this.pendDate,
          Delete: isDelete,
          IsToReview: true
        } as DocumentUpdateRetentionUpdateParams;
        await ApiConfiguration.api().document.documentUpdateRetentionUpdate(updatePayload);
        Toast.showSuccess('Retention updated successfully!');

        // Remove the document from the data array
        docs.splice(currentIdx, 1);

        // Select the next document (or previous if at end)
        let nextIdx = currentIdx;
        if (nextIdx >= docs.length) {
          nextIdx = docs.length - 1;
        }
        this.documentIdBeingDisplayed = docs[nextIdx]?.CB_DOCID ?? 0;
        await this.onRowClicked(this.documentIdBeingDisplayed);
      } catch {
        Toast.showError('An error occured updating retention.');
      } finally {
        this.isUpdating = false;
      }
    },
    onPendDateInput(this: any, value: string) {
      this.pendDate = value;
      this.validatePendDate(value);
    },
    validatePendDate(this: any, value?: string) {
      this.$validator.errors.remove('pendDateValidationErrors');
      let isValid = true;
      let errorMsg = '';

      if (!value) {
        isValid = false;
        errorMsg = 'A date is required.';
      } else {
        const dateValue = new Date(value);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        if (dateValue <= today) {
          isValid = false;
          errorMsg = 'The date must be set in the future.';
        }
      }

      if (!isValid) {
        this.$validator.errors.add({
          field: 'pendDateValidationErrors',
          msg: errorMsg
        });
      }
      return isValid;
    },
    clearErrors(this: any) {
      this.$validator.errors.remove('pendDateValidationErrors');
    }
  },
  async mounted(this: any) {
    try {
      await this.getRetentionCounts();
    } finally {
      this.isLoading = false;
    }
  },
  created(this: any) {
    this.DOCUMENTS_PER_PAGE = 200;
    this.DOCUMENT_TABS = [{ componentName: 'MStoreDocumentInformationTab', description: 'Document Information' }] as DocumentTabModel[];
    this.PEND_TYPES = Object.values(DocumentRetentionPendType);
  },
  components: {
    LoadingSpinner: () => import('@/components/shared/LoadingSpinner.vue'),
    LoadingOverlay: () => import('@/components/shared/LoadingOverlay.vue'),
    MStoreSimpleTable: () => import('@/components/shared/Table/MStoreSimpleTable.vue'),
    BackgroundDeleteButton: () => import('@/components/document/BackgroundDeleteButton.vue'),
    DocumentViewer,
    MStoreFormDatePicker,
    MStoreDocumentInformationTab: () => import('@/components/shared/Tabs/MStoreDocumentInformationTab.vue')
  }
});
